import React, {useState} from 'react';
// Modal Sheet
import Sheet from 'react-modal-sheet';

import { MdLocationPin } from 'react-icons/md';
import { TbLocation } from 'react-icons/tb';

// React player
import ReactPlayer from 'react-player'
// Paquete para traduccion i18n
import { useTranslation } from 'react-i18next';

const Contacto = () => {

    // Hook importado de 'react-i18next'
    const { t } = useTranslation(); 

    // Set State del modal Sheeet for each modal
    const [isOpen, setOpen] = useState(false);

  return (
    <div>
        <button onClick={() => setOpen(true)}><TbLocation className='text-5xl text-white bg-primary p-3 rounded-lg'/></button>
        <Sheet isOpen={isOpen} onClose={() => setOpen(false)}>
            <Sheet.Container>
                <Sheet.Header />
                    <Sheet.Content className='mx-12 my-3'>
                        <h1 className='font-bold text-xl mb-2'>{t('home_contact1')}</h1>
                        <p className='font-medium text-basis mb-5 text-justify'>{t("home_contact2")}</p>
                        {/* Video playing */}
                        <div className='mt-5'>
                            <ReactPlayer
                                url= 'https://youtu.be/K9KaPXWeHEw'
                                width='100%'
                                height='100%'
                                controls = {true}
                            />
                        </div>
                        <div className='flex justify-center my-5'><iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15032.090787348494!2d-101.5769528!3d19.6263274!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x229c85829c3e8e7a!2sCocina%20tradicional%20La%20Casa%20de%20Blanca!5e0!3m2!1ses-419!2smx!4v1673913779146!5m2!1ses-419!2smx" style={{width: 310, height: 200}} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className='rounded-2xl border-primary' samesite='None' title='21'></iframe></div>
                        <div className='flex justify-center'><a href="https://goo.gl/maps/F1VydmJCzARU9n3x6" className='bg-secondary text-white text-xl font-bold border-10 py-6 rounded-2xl shadow-2xl w-screen text-center hover:transition-all hover:duration-200 hover:bg-primary flex items-center gap-2 justify-center'><MdLocationPin />{t("home_contact4")}</a></div>
                        <p className='font-bold text-lg my-4'>{t("home_contact3")}</p>
                        <div className='flex text-sm justify-between'>
                            <div>
                                <div className='flex justify-between gap-1'><div>{t("home_contact5")}</div><div>10:30 - 17:30</div></div>
                            </div>
                        </div>
                    </Sheet.Content>
                </Sheet.Container>
            <Sheet.Backdrop />
        </Sheet>
    </div>
  )
}

export default Contacto